// import $ from "jquery";
export default {
    name: "destockage",
    components: {},
    props: [],
    data() {
        return {
            loading: false,
            filtered_articles: [],
            entres: [],
            value: "",
            user_role: "",
            is_greater: [],
            is_empty: false,

            one_is_greater: false
        };
    },

    watch: {

    },

    computed: {
        articles() {
            return this.$store.getters["destokages"];
        },

        userCredentials() {
            return this.$store.getters["authInfo"];
        },
        activeRole() {
            return this.$store.getters["activeRole"];
        },
    },

    mounted() {
        this.$store.dispatch("getDestockageListes")

        // if (this.activeRole.nom != "ROLE_ADMINISTRATEUR") {
        //     if (this.activeRole.nom == "ROLE_PHARMACIEN") {
        //         this.$router.push({ path: "/stock" });
        //     } else if (this.activeRole.nom == "ROLE_PHARMACIEN_INTERMITENT") {
        //         this.$router.push({ path: "/ventes" });
        //     }
        // }
    },
    methods: {
        filterArticle() {
            this.filtered_articles = [];

            if (this.value.length > 1) {
                this.articles.forEach((element) => {
                    if (
                        element.medicament.toLowerCase().includes(this.value.toLowerCase())
                    ) {
                        this.filtered_articles.push(element);
                    }
                });
            }
            this.is_empty = false
        },

        choiceArticle(article) {
            this.entres.push({
              article: article.medicament_id,
              libelle: article.medicament,
              lot_article: article.lot_article,
              motif: null,
              quantite: null,
              initial: article.nombre_disponible,
              article_repartition_id: article.article_repartition_id,
              user_id: this.userCredentials.user.id,
            });

            this.value = "";
            this.filtered_articles = [];
        },

        deleteEntre(index) {
            this.entres.splice(index, 1);
        },

        /**
         * Clear Message error for a specific input 
         * @param index
         */
        clearError(index) {
            this.is_greater[index] = false
            this.one_is_greater = false
        },

        async submitForm() {
            const isValid = await this.$refs.observer.validate();

            if (!isValid) {
                return;
            }

            if (this.entres.length == 0) {
                this.is_empty = true
                return;
            }

            this.one_is_greater = false
            this.entres.forEach((element, i) => {
                if (this.entres[i].quantite > element.initial) {
                    this.is_greater[i] = true
                    this.one_is_greater = true
                } 
            });

            if (this.one_is_greater) {
                return;
            }

            this.loading = true
            
            await this.$store.dispatch("saveDestockage", this.entres).then((response) => {
                if (response) {
                    this.$router.push({ path: "/destockages" });
                }
                this.loading = false;
            });
        },
    },
};
